import { Navigate, Outlet, useLocation } from "react-router";
import { isLoggedIn } from "./behavior/security/auth.service";
import { PageState } from "./constants";

const ProtectedRoute = () => {
    const location = useLocation();
    if (!isLoggedIn()) {
        const redirectUrl = encodeURIComponent(location.pathname);
        return <Navigate to={`/?state=${PageState.SESSION_EXPIRED}&redirectUrl=${redirectUrl}`} />;
    }
    return <Outlet />;
};

export default ProtectedRoute;
